import CONSTANTS from '../constants';
import { alerts } from './alerts';
import CheckinService from '../services/checkinService';

export function checkinMember(doorId, history = {}) {
  return dispatch => {
    dispatch({type: CONSTANTS.ACTIONS.SPINNER.SHOW});
    CheckinService.createCheckin(doorId).then((response) => {
      dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
      if(response.data.success) {
        dispatch(checkinAction(response.data.checkin));
        dispatch(alerts.success('Appointment created successfully. A confirmation email has been sent'));
      } else {
        dispatch(alerts.error(response.data.message));
      }
    }).catch((error) => {
      dispatch({type: CONSTANTS.ACTIONS.SPINNER.HIDE});
      dispatch(alerts.error(error.message));
    });
  };

  function checkinAction(checkin) { return {type: CONSTANTS.ACTIONS.CHECKIN.CREATE, checkin: checkin} }
}

export function fetchCheckins(params) {
  return dispatch => {
    // Reset checkins to null so that component re renders itself in initial state.
    dispatch(checkinsAction(null));
    CheckinService.fetchCheckins(params).then((response) => {
      dispatch(checkinsAction(response.data));
    }).catch((error) => {
      dispatch(alerts.error(error.message));
    });
  };

  function checkinsAction(checkins) { return {type: CONSTANTS.ACTIONS.CHECKIN.GET.CHECKINS, checkins: checkins} }
}